// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Winner_circle__wnYy5{
    width: 300px;
    height: 300px;
    border: 6px solid greenyellow;
    border-radius: 50%;
    animation: Winner_expandAnimation__xZElA 2s ease forwards;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap:10px;

}
.Winner_text__y4a9v{
    font-size: 30px;
    color:white;
    font-family: Popins,sans-serif;
}
.Winner_containerCircle__NPdKJ{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 20;
    
    display: flex;
    justify-content: center;
    align-items: center;
}
@keyframes Winner_expandAnimation__xZElA {
    0% {
        opacity: 0;
        transform: scale(0.1); /* Начальный масштаб */

    }
    100% {
        opacity: 1;

        transform: scale(1); /* Конечный масштаб */

    }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Winner/Winner.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,yDAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;;AAEZ;AACA;IACI,eAAe;IACf,WAAW;IACX,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;;IAEX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI;QACI,UAAU;QACV,qBAAqB,EAAE,sBAAsB;;IAEjD;IACA;QACI,UAAU;;QAEV,mBAAmB,EAAE,qBAAqB;;IAE9C;AACJ","sourcesContent":[".circle{\n    width: 300px;\n    height: 300px;\n    border: 6px solid greenyellow;\n    border-radius: 50%;\n    animation: expandAnimation 2s ease forwards;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap:10px;\n\n}\n.text{\n    font-size: 30px;\n    color:white;\n    font-family: Popins,sans-serif;\n}\n.containerCircle{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 20;\n    \n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n@keyframes expandAnimation {\n    0% {\n        opacity: 0;\n        transform: scale(0.1); /* Начальный масштаб */\n\n    }\n    100% {\n        opacity: 1;\n\n        transform: scale(1); /* Конечный масштаб */\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `Winner_circle__wnYy5`,
	"expandAnimation": `Winner_expandAnimation__xZElA`,
	"text": `Winner_text__y4a9v`,
	"containerCircle": `Winner_containerCircle__NPdKJ`
};
export default ___CSS_LOADER_EXPORT___;
